module.exports = __webpack_public_path__ + "static/img/banner1.91f2921f.jpg";